export const OVERFLOW_SCROLL_ITEM_CLASS = 'pgn__overflow-scroll-item';
